import { createContext, useContext } from 'react';

import { UserType } from '@constants_common';

type AuthContext = {
  userType: UserType;
  dashboardLogin: (formData: FormData, userType: UserType) => Promise<any>;
  isAuthenticated: (params: { userType: UserType; pagePath: string }) => Promise<boolean>;
  logout: (userType: string) => void;
};

export const authContext = createContext<AuthContext | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(authContext);
  if (context === undefined) {
    throw Error('authContext is undefined');
  }
  return context;
};
